import { useSelector } from "react-redux";
import LeaveCard from "../Common/LeaveCards";

import "./ScheduledLeaves.css";
import PageLoader from "components/common/PageLoader";
import { useEffect, useState } from "react";

function NoDataCard() {
  return (
    <div className="no-card-container">
      <p className="no-card-text">No scheduled time-off</p>
    </div>
  );
}

function ScheduledLeaves() {
  const [scheduledLeaveRequests, setScheduledLeaveRequests] = useState([]);
  const leaveRequests = useSelector((state) => state?.TimeoffLeaveRequests?.leaveRequests || []);
  const loadingLeaveRequests = useSelector((state) => state?.TimeoffLeaveRequests?.loadingLeaveRequests);

  useEffect(() => {
    setScheduledLeaveRequests(leaveRequests?.scheduled || []);
  }, [leaveRequests]);

  return (
    <>
      {loadingLeaveRequests && <PageLoader />}
      <div className="pending-leaves-container-emp flex-col">
        <div className="mt-1">
          {scheduledLeaveRequests?.length ? (
            <div className="flex flex-col gap-075">
              {scheduledLeaveRequests.map((leave) => (
                <LeaveCard type="scheduled" data={leave} />
              ))}
            </div>
          ) : (
            <NoDataCard />
          )}
        </div>
      </div>
    </>
  );
}

export default ScheduledLeaves;
